import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// https://www.freakyjolly.com/angular-how-to-cancel-http-calls-on-router-change/
@Injectable()
export class HttpCancelService {

  private pendingHTTPRequests$ = new Subject<void>();

  constructor() {
  }

  public cancelPendingRequests() {
    this.pendingHTTPRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.pendingHTTPRequests$.asObservable();
  }
}
